class InfiniteScroll {
  constructor() {
    document.addEventListener('click', this.handleClick.bind(this));
  }

  async handleClick(event) {
    const trigger = event.target.closest('[data-load-more]');
    if (!trigger) return;

    event.preventDefault();
    const url = trigger.getAttribute('href');
    const wrapper = trigger.closest('[data-pagination-wrapper]');
    const grid = document.querySelector('[data-product-grid]');
    if (!url || !wrapper || !grid) return;

    trigger.setAttribute('aria-disabled', 'true');
    const response = await fetch(url);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextGrid = doc.querySelector('[data-product-grid]');
    const nextPagination = doc.querySelector('[data-pagination-wrapper]');
    if (nextGrid) {
      grid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
    }
    if (nextPagination) {
      wrapper.innerHTML = nextPagination.innerHTML;
    } else {
      wrapper.remove();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new InfiniteScroll();
});
